import { LogoComponent } from './logo/logo.component';

export const Components = [
	LogoComponent,
];
